<template>
  <div class="header w">
    <!-- 标志模块 -->
    <a href="/#/main" class="logo">
      <img src="../assets/logo.png" />
    </a>
    <!-- 文字导航栏模块 -->
    <div class="nav">
      <ul>
        <li>
          <router-link to="/main" id="text"><a href="#">首页</a></router-link>
        </li>
        <li>
          <router-link to="/active" id="text"
            ><a href="#">新闻中心</a></router-link
          >
        </li>
        <li>
          <router-link to="/fund" id="text"
            ><a href="#">基金报告</a></router-link
          >
        </li>
        <li>
          <router-link to="/about" id="text">
            <el-button type="primary" round class="header-button"
              >关于我们</el-button
            >
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1"
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* .w {
  margin: 0 auto;
} */
li {
  list-style: none;
}
a {
  text-decoration: none;
}
.header {
  display: block;
  margin: 0 auto;
  min-width: 880px;
  background-color: white;
}
.logo {
  vertical-align: top;
  display: inline-block;
}

.nav {
  float: right;
  margin-left: 60px;
}
.nav ul li {
  float: left;
  margin: 5px 10px 0 10px;
}
.nav ul li a {
  display: block;
  height: 100%;
  padding: 10px;
  color: black;
}
.nav ul li a:hover {
  color: beige;
}
.header-button {
  background-color: #97b9ff;
  border-color: #97b9ff;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue